<template>
  <!-- 申请发票 -->
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    append-to-body
    width="60%"
  >
    <div class="title">开票信息</div>
    <el-descriptions
      class="margin-top"
      :column="2"
      :labelStyle="{ 'text-align': 'right', width: '200px' }"
      border
    >
      <el-descriptions-item>
        <template slot="label"> 企业名称： </template>
        {{ form.warrantee }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 统一社会信用代码： </template>
        {{ form.warranteeCode }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 注册地址： </template>
        {{ form.warranteeAddress }}
      </el-descriptions-item>
      <!-- <el-descriptions-item>
        <template slot="label"> </template>
      </el-descriptions-item> -->
      <el-descriptions-item>
        <template slot="label"> 开户行名称： </template>
        {{ form.bankName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 开户行基本账号： </template>
        {{ form.bankCode }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 固定电话： </template>
        {{ form.invoicePhone }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 电子邮箱： </template>
        {{ form.invoiceEmail }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 收件人姓名： </template>
        {{ form.recipient }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 收件人手机： </template>
        {{ form.recipientPhone }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 收件地址： </template>
        {{ form.recipientAddress }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 邮编： </template>
        {{ form.recipientZipCode }}
      </el-descriptions-item>
    </el-descriptions>
    <div class="title">订单信息</div>
    <el-descriptions
      class="margin-top"
      :column="2"
      border
      :labelStyle="{ 'text-align': 'right', width: '200px' }"
    >
      <el-descriptions-item>
        <template slot="label"> 订单号： </template>
        {{ form.orderNum }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 项目名称： </template>
        {{ form.projectName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 保证金金额： </template>
        {{ form.guaMoney }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 标段名称： </template>
        {{ form.bidName }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 订单金额： </template>
        {{ form.orderFee }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 申请日期： </template>
        {{ form.orderCreateTime }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 开票总金额： </template>
        {{ form.orderFee }}
      </el-descriptions-item>
    </el-descriptions>
    <div class="title">发票信息</div>
    <el-descriptions
      class="margin-top"
      :column="2"
      border
      :labelStyle="{ 'text-align': 'right', width: '200px' }"
    >
      <el-descriptions-item>
        <template slot="label"> 发票类型： </template>
        <span v-if="form.invoiceType=='0'">普票</span>
        <span v-if="form.invoiceType=='1'">专票</span>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 申请时间： </template>
        {{ form.applyDate }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 快递单号： </template>
        {{ form.trackingNum }}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 开票时间： </template>
        {{ form.invoiceTime }}
      </el-descriptions-item>
      <el-descriptions-item v-if="form.invoiceType=='1'">
        <template slot="label"> 快递公司： </template>
        {{ form.expressCompany }}
      </el-descriptions-item>
      <el-descriptions-item v-if="form.invoiceType=='0'">
        <template slot="label"> 发票下载： </template>
        <div v-show="(form.invoiceStatus == '3' || form.invoiceStatus == '4')&&form.invoiceType==0">
          <el-link
            :href="form.invoiceUrl"
            target="_blank"
            > <el-button icon="el-icon-download" type="primary" size="mini"
              >点击下载</el-button
            ></el-link
          >
          <!-- <el-link
            :href="[
              '/api/OrderListController/downloadGuaranteeReceipt?address=' +
                form.invoiceUrl,
            ]"
            target="_blank"
            > <el-button icon="el-icon-download" type="primary" size="mini"
              >点击下载</el-button
            ></el-link
          > -->
        </div>
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label"> 邮寄时间： </template>
        {{ form.trackingTime }}
      </el-descriptions-item>
    </el-descriptions>
    <div style="text-align: center; margin-top: 52px">
      <el-button type="info" @click="back">关闭</el-button>
    </div>
    <!-- </el-form> -->
  </el-dialog>
</template>

<script type="text/ecmascript-6">
export default {
  data() {
    return {
      ordinary: false,
      special: false,
      form: {},
    };
  },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: null,
    },
  },
  watch: {
    formData: {
      handler(v) {
        if (v) {
          this.form = v;
        }
      },
    },
  },
  computed: {
    visible: {
      get() {
        return this.dialogVisible;
      },
      set(v) {
        this.$emit("update:dialogVisible", v);
      },
    },
  },
  methods: {
    typeOne() {
      this.special = false;
      this.ordinary = !this.ordinary;
    },
    typeTwo() {
      this.ordinary = false;
      this.special = !this.special;
    },
    back() {
      // this.$router.push("/invoice");
      this.visible=false
    },
  },
  mounted() {
  },
  components: {},
};
</script>

<style scoped>
.page {
  background-color: #fff;
  height: 100%;
  margin: 0 20px;
}
.elCard {
  background-color: #0065b3 !important;
  color: #fff;
}
.margin-top{
  margin: 20px 0;
}
</style>
